module.exports = __webpack_public_path__ + "files/7f80947e054f4c61caa14762f3a2f45a.png";